// extracted by mini-css-extract-plugin
export default {"accordionContainer":"accordion_accordionContainer__tq2Mp","underlayGradient":"accordion_underlayGradient__Wo57v","overlayGradient":"accordion_overlayGradient__sO8kC"};